var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCaretLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.938 16 5.431 5.43a.968.968 0 0 1 .284.697.943.943 0 0 1-.284.709.958.958 0 0 1-.702.29.958.958 0 0 1-.703-.29l-5.992-5.992A1.108 1.108 0 0 1 11.63 16a1.107 1.107 0 0 1 .341-.844l5.992-5.992a.968.968 0 0 1 .696-.283c.28-.005.516.09.71.283.192.193.289.428.289.703 0 .275-.097.509-.29.702L13.94 16Z",
  fill: "currentColor"
})));

export default SvgCaretLeft;